export const RouteEnumFinal = {
    SPLASH : "/",
    // SPLASH_USERNAME : "/:arg",
    MAIN:"/:arg/*",
    MAIN_URL_GENERATE:"/:arg",

    CLEAR_CACHE : "/system/clear",
    CLEAR_CACHE_URL_GENERATE : "/system/clear",

    AUTH_LOGIN_PHONE:"/login",
    AUTH_LOGIN_PHONE_URL_GENERATE:"/login",

    AUTH_LOGIN_VERIFY:"/verify",
    AUTH_LOGIN_VERIFY_URL_GENERATE:"/verify",

    AUTH_LOGIN_NAME:"/register",
    AUTH_LOGIN_NAME_URL_GENERATE:"/register",

    AUTH_CREATE_STORE:"/store/create",
    AUTH_CREATE_STORE_URL_GENERATE:"/store/create",


    ADDRESS_LIST:'/:arg/address',
    ADDRESS_LIST_URL_GENERATE:'/:arg/address',

    ADDRESS_ADD:'/address/add',
    ADDRESS_ADD_URL_GENERATE:'/address/add',

    ADDRESS_EDIT:'/:arg/address/edit/:arg',
    ADDRESS_EDIT_URL_GENERATE:'/:arg/address/edit/:arg',

    QR_CODE_GENERATOR:'/qr/generate',
    QR_CODE_GENERATOR_URL_GENERATE:'/qr/generate',

    STORE_STATISTICS:'/statistics/general',
    STORE_STATISTICS_URL_GENERATE:'/statistics/general',

    SOCIAL_LIST:'/socials',
    SOCIAL_LIST_URL_GENERATE:'/socials',

    STORE_GALLERY:"/gallery",
    STORE_GALLERY_URL_GENERATE:"/gallery",

    GUILD_LIST:'/guilds',
    GUILD_LIST_URL_GENERATE:'/guilds',

    CATEGORY_LIST : '/panel/categories',
    CATEGORY_LIST_URL_GENERATE : '/panel/categories',

    CATEGORY_LIST_SORTING : '/panel/categories/sorting',
    CATEGORY_LIST_SORTING_URL_GENERATE : '/panel/categories/sorting',

    CATEGORY_PRODUCT_LIST : '/panel/categories-products',
    CATEGORY_PRODUCT_LIST_URL_GENERATE : '/panel/categories-products',

    PRODUCTS_QUICK_EDIT : '/panel/products-quick-edit/:arg',
    PRODUCTS_QUICK_EDIT_URL_GENERATE : '/panel/products-quick-edit/:arg',

    PRODUCT_LIST_SORTING : '/panel/products/sorting',
    PRODUCT_LIST_SORTING_URL_GENERATE : '/panel/products/sorting',

    STORE_MAIN_VIEW : "/",
    STORE_MAIN_VIEW_URL_GENERATE : "/",

    STORE_SHOW_FOR_CUSTOMER:"/store/for-customer/*",
    STORE_SHOW_FOR_CUSTOMER_URL_GENERATE:"/store/for-customer/:arg",

    PRODUCT_ADD:'/product/add',
    PRODUCT_ADD_URL_GENERATE:'/product/add',

    PRODUCT_GALLERY:'/p/:arg/gallery',
    PRODUCT_GALLERY_URL_GENERATE:'/p/:arg/gallery',

    PRODUCT_SHOW:'/p/:arg',
    PRODUCT_SHOW_URL_GENERATE:'/p/:arg',

    PRODUCT_SHOW_OWNER_MODE:'/p/:arg/owner',
    PRODUCT_SHOW_OWNER_MODE_URL_GENERATE:'/p/:arg/owner',

    PRODUCT_EDIT:'/p/:arg/edit',
    PRODUCT_EDIT_URL_GENERATE:'/p/:arg/edit',


    USER_PROFILE : "/profile",
    USER_PROFILE_URL_GENERATE : "/store/profile",

    STORE_PANEL : "/panel",
    STORE_PANEL_URL_GENERATE : "/store/panel",
}

export function getGeneratedRoute(route,...args) {
    let splitRoute = route.split("/");
    for (let i = 0; i < splitRoute.length; i++) {
        if (splitRoute[i].startsWith(":arg")) {
            // splitRoute[i] = args[0];
            // args.shift();
            splitRoute[i] = args.shift();
        }
    }
    return splitRoute.join("/");
}
